// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"11277b19b1c099556b74","feed-creation-page":"88eee93ce4c5ea401b44","feed-manager-page":"920d9fac74eb10affba9"}[chunkId] + ".js";
};